// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__bTukt","title":"Item_title___eNtb","content":"Item_content__TD36t","date":"Item_date__Hnf3c","image":"Item_image__YQ_B8","arrow":"Item_arrow__aEufN"};